var _excluded = ["container"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import $7SXl2$babelruntimehelpersesmextends from "@babel/runtime/helpers/esm/extends";
import { forwardRef as $7SXl2$forwardRef, createElement as $7SXl2$createElement } from "react";
import $7SXl2$reactdom from "react-dom";
import { Primitive as $7SXl2$Primitive } from "@radix-ui/react-primitive";

/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/
var $f1701beae083dbae$var$PORTAL_NAME = 'Portal';
var $f1701beae083dbae$export$602eac185826482c = /*#__PURE__*/$7SXl2$forwardRef(function (props, forwardedRef) {
  var _globalThis$document;
  var _props$container = props.container,
    container = _props$container === void 0 ? globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body : _props$container,
    portalProps = _objectWithoutProperties(props, _excluded);
  return container ? /*#__PURE__*/$7SXl2$reactdom.createPortal(/*#__PURE__*/$7SXl2$createElement($7SXl2$Primitive.div, $7SXl2$babelruntimehelpersesmextends({}, portalProps, {
    ref: forwardedRef
  })), container) : null;
});
/*#__PURE__*/
Object.assign($f1701beae083dbae$export$602eac185826482c, {
  displayName: $f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/
var $f1701beae083dbae$export$be92b6f5f03c0fe9 = $f1701beae083dbae$export$602eac185826482c;
export { $f1701beae083dbae$export$602eac185826482c as Portal, $f1701beae083dbae$export$be92b6f5f03c0fe9 as Root };